import { interactionModeRequestedAttributes } from './interactionModeRequestedAttributes';
import type { SendMessageTrackingAttributes } from './sendMessageActionTypes';

/**
 * Helper function to stop/end metrics, that can only be called once
 */
export const getRequestedModeAttributes = (
	trackingAttributes: SendMessageTrackingAttributes,
): { interactionModeRequested?: string; aiFeatureName?: string } => ({
	...interactionModeRequestedAttributes(trackingAttributes.interactionModeRequested),
	...(trackingAttributes.aiFeatureName && { aiFeatureName: trackingAttributes.aiFeatureName }),
});
